import axios from 'axios';
import { Modal } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
	const formModalAll = document.querySelectorAll('.form-modal');

	if (formModalAll.length === 0) return;

	formModalAll.forEach(modal => {
		const forms = modal.querySelectorAll('form');

		forms.forEach(form => {
			form.addEventListener('submit', (event) => {
				event.preventDefault();

				let { body } = document;

				body.dataset.bsOverflow = "auto";
				body.dataset.bsPaddingRight = "0px";

				const { action: url } = event.currentTarget;
				let data = new FormData(form);
				//form.reset();

				axios.post(url, data, {
					responseType: 'json',
				}).then(function (response) {
					if (response.data.status) {
						return response;
					} else {
						let err = 'False status response';
						console.error(err);
						throw new Error(err);
					}
				}).then(function (response) {
					let button = form.querySelector('button');
					let div = document.createElement('div');
					div.classList.add('text-white', 'bg-green', 'px-4', 'py-2', 'mt-4');
					div.append('Форма отправлена! С вами свяжутся при необходимости.');

					form.replaceChild(div, button);
				}).catch(function (error) {
					console.error(error.message);
					throw new Error(error.message);
				});
			})
		})
	})

}, { once: true });
